import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
import Tooltip from '@material-ui/core/Tooltip';
import HelpIcon from '@material-ui/icons/Help';
import useProductParameterValueComponent from '../useProductParameterValueComponent';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: theme.spacing(1),
      '&:nth-child(even)': {
        backgroundColor: theme.palette.grey[200]
      },
      '&:nth-child(odd)': {}
    },
    label: _extends({}, theme.typography.subtitle2, _defineProperty({
      flexBasis: '20%'
    }, theme.breakpoints.down('sm'), {
      flexBasis: '30%'
    })),
    unit: _extends({}, theme.typography.caption, {
      flexBasis: '10%'
    }),
    value: _extends({}, theme.typography.body2, {
      flexBasis: '70%'
    }),
    tooltip: {
      alignItems: 'center',
      display: 'flex'
    },
    tooltipIcon: {
      color: theme.palette.primary.light,
      marginLeft: theme.spacing(1)
    }
  };
}, {
  name: 'SxComProductParameter'
});

function ProductParametersListItemGroupParameter(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      parameter = _ref.parameter,
      rest = _objectWithoutProperties(_ref, ["classes", "className", "parameter"]);

  var classes = useStyles({
    classes: pClasses
  });
  var helperText = parameter.helperText,
      label = parameter.label,
      unit = parameter.unit;
  var ProductParameterValueComponent = useProductParameterValueComponent();
  return /*#__PURE__*/React.createElement("div", _extends({}, pickHTMLProps(rest), {
    className: clsx(classes.root, className)
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.label
  }, helperText ? /*#__PURE__*/React.createElement("div", {
    className: classes.tooltip
  }, label, /*#__PURE__*/React.createElement(Tooltip, {
    title: helperText
  }, /*#__PURE__*/React.createElement(HelpIcon, {
    className: classes.tooltipIcon,
    fontSize: "small",
    color: "inherit"
  }))) : label), /*#__PURE__*/React.createElement("div", {
    className: classes.value
  }, /*#__PURE__*/React.createElement(ProductParameterValueComponent, {
    parameter: parameter
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.unit
  }, unit));
}

ProductParametersListItemGroupParameter.propTypes = {
  classes: PropTypes.shape({
    label: PropTypes.string,
    root: PropTypes.string,
    tooltip: PropTypes.string,
    tooltipIcon: PropTypes.string,
    unit: PropTypes.string,
    value: PropTypes.string
  }),
  className: PropTypes.string,
  parameter: PropTypes.shape({
    helperText: PropTypes.string,
    label: PropTypes.string.isRequired,
    unit: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.shape({
      label: PropTypes.arrayOf(PropTypes.shape({
        language: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired
      })),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
    })])
  }).isRequired
};
ProductParametersListItemGroupParameter.defaultProps = {
  classes: undefined,
  className: undefined
};
export default ProductParametersListItemGroupParameter;